"use client";

import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DirectContactStrip() {
  return <section id="direct-contact-strip" className="w-full" style={{
    borderTop: "1px solid hsl(270 100% 60%)",
    backdropFilter: "blur(24px)",
    WebkitBackdropFilter: "blur(24px)",
    backgroundColor: "hsl(240 10% 98% / 0.85)"
  }}>
      <div className="mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 px-8 py-5" style={{
      maxWidth: "80rem"
    }}>
        {}
        <Link to="mailto:hello@aicommercials.ai" className="flex items-center gap-2 group">
          <Mail className="shrink-0" size={18} style={{
          color: "var(--chart-1)"
        }} />
          <span className="font-default font-bold text-sm sm:text-base tracking-wide" style={{
          fontFamily: "var(--font-heading)",
          color: "var(--chart-1)",
          textShadow: "0 0 12px hsl(180 100% 50% / 0.45)",
          transition: "text-shadow 0.2s ease"
        }}>
            hello@aicommercials.ai
          </span>
        </Link>

        {}
        <Button variant="outline" size="default" asChild className="
            relative overflow-hidden
            border
            font-default text-sm font-medium
            rounded-lg
            transition-all duration-150
            group
          " style={{
        borderColor: "hsl(270 100% 60%)",
        color: "hsl(270 100% 60%)",
        background: "transparent",
        borderRadius: "8px"
      }}>
          <Link to="#">
            <span className="relative z-10 select-none" style={{
            fontFamily: "var(--font-heading)"
          }}>
              Return to Studio
            </span>
            {}
            <span aria-hidden className="
                absolute inset-0 flex items-center justify-center
                opacity-0 group-hover:opacity-100
                pointer-events-none
                transition-opacity duration-75
              " style={{
            fontFamily: "var(--font-heading)",
            fontSize: "inherit",
            color: "hsl(180 100% 50%)",
            clipPath: "inset(0 0 60% 0)",
            transform: "translateX(-2px)",
            mixBlendMode: "screen"
          }}>
              Return to Studio
            </span>
            <span aria-hidden className="
                absolute inset-0 flex items-center justify-center
                opacity-0 group-hover:opacity-100
                pointer-events-none
                transition-opacity duration-75
              " style={{
            fontFamily: "var(--font-heading)",
            fontSize: "inherit",
            color: "hsl(270 100% 80%)",
            clipPath: "inset(60% 0 0 0)",
            transform: "translateX(2px)",
            mixBlendMode: "screen"
          }}>
              Return to Studio
            </span>
          </Link>
        </Button>
      </div>

      <style>{`
        #direct-contact-strip a[href^="mailto"] .group:hover {
          text-shadow: 0 0 20px hsl(180 100% 50% / 0.8), 0 0 40px hsl(180 100% 50% / 0.4);
        }

        #direct-contact-strip .group:hover [aria-hidden] {
          animation: glitch-strip 0.3s steps(2) infinite;
        }

        @keyframes glitch-strip {
          0%   { transform: translateX(-2px); opacity: 0.85; }
          25%  { transform: translateX(2px);  opacity: 0.6;  }
          50%  { transform: translateX(-1px); opacity: 0.9;  }
          75%  { transform: translateX(1px);  opacity: 0.5;  }
          100% { transform: translateX(-2px); opacity: 0.85; }
        }
      `}</style>
    </section>;
}